import axios from "axios";
import { cleanToken } from "@/utils/auth-token";

const prefix = import.meta.env.VITE_BE_HOST || "http://localhost:8080";

const apiLogin = (data) => {
  return axios.post(`${prefix}/user/login`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const getInfoFromToken = (token) => {
  const config = {
    headers: {
      "x-access-token": cleanToken(token),
    },
  };

  return axios.post(`${prefix}/verify/client`, {}, config);
};

const apiAddLocation = (data, token, assignLocationToUsers) => {
  const config = {
    headers: {
      "x-access-token": cleanToken(token),
    },
  };
  return axios.post(
    `${prefix}/params/addLocation`,
    { ...data, assignLocationToUsers },
    config,
  );
};

const apiGetLocations = (token) => {
  const config = {
    headers: {
      "x-access-token": cleanToken(token),
    },
  };

  return axios.get(`${prefix}/params/client/locations`, config);
};

const apiAddUser = (data, token) => {
  const config = {
    headers: {
      "x-access-token": cleanToken(token),
    },
  };
  return axios.post(`${prefix}/user/registerUser`, data, config);
};

const apiGetUsers = (token) => {
  const config = {
    headers: {
      "x-access-token": cleanToken(token),
    },
  };
  return axios.post(`${prefix}/user/getUsers`, {}, config);
};

const apiUpdateUser = (data, token) => {
  const config = {
    headers: {
      "x-access-token": cleanToken(token),
    },
  };
  return axios.post(`${prefix}/user/updateUser`, data, config);
};

const apiUpdateLocation = (data, token) => {
  const config = {
    headers: {
      "x-access-token": cleanToken(token),
    },
  };
  return axios.post(`${prefix}/params/updateLocation`, { ...data }, config);
};

const apiGetServices = (token) => {
  const config = {
    headers: {
      "x-access-token": cleanToken(token),
    },
  };
  return axios.get(`${prefix}/params/getServices`, config);
};

const apiUpdateCustomer = (data, token) => {
  const config = {
    headers: {
      "x-access-token": cleanToken(token),
    },
  };
  return axios.post(`${prefix}/appointment/updateCustomer`, data, config);
};

export const apiGetUserPermissions = () => {
  const token = localStorage.getItem("usr_token");
  const config = {
    headers: {
      "x-access-token": cleanToken(token),
    },
  };
  return axios.get(`${prefix}/user/user_permissions`, config);
};

export const apiGetPreferredLanguage = (token) => {
  const config = {
    headers: {
      "x-access-token": cleanToken(token),
    },
  };
  return axios.get(`${prefix}/user/preferred_language`, config);
};
export {
  apiUpdateCustomer,
  apiLogin,
  apiAddLocation,
  apiGetLocations,
  apiAddUser,
  apiGetUsers,
  apiUpdateUser,
  apiUpdateLocation,
  apiGetServices,
  getInfoFromToken,
};
